import { render, staticRenderFns } from "./DownloadsPage.vue?vue&type=template&id=2700acac&scoped=true"
import script from "./DownloadsPage.vue?vue&type=script&lang=js"
export * from "./DownloadsPage.vue?vue&type=script&lang=js"
import style0 from "./DownloadsPage.vue?vue&type=style&index=0&id=2700acac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2700acac",
  null
  
)

export default component.exports